import {
  Box,
  ImageList,
  ImageListItem,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { projectList, projectTypes } from "../../assets/Json/staticData";
import ProjectCard from "../../components/ProjectCard";
import ProjectDetails from "./ProjectDetails";
import NoData from "../../components/NoData";
import LoadingSpinner from "../../components/LoadingComponent/LoadingSpinner"; // Make sure this path is correct
import ImageLoading from "../../components/LoadingComponent/ImageLoading";
import { handleImageLoad } from "../../helpers/handleLoading";
import Seo from "../../components/Seo/Seo";

const Projects = () => {
  const [tabValue, setTabValue] = useState("");
  const [open, setOpen] = useState(false);
  const [projects, setProjects] = useState([]);
  const [projectDetails, setProjectDetails] = useState();
  const [imgLoaded, setImgLoaded] = useState({});
  const isMobile = window.innerWidth < 768; // Mobile view condition

  useEffect(() => {
    handleChangeTab("architecture");
  }, []);

  const handleChangeTab = (newValue) => {
    if (newValue === tabValue) return; 
    setTabValue(newValue);
    const updatedProjects = projectList.filter((project) => project?.type === newValue);
    setProjects(updatedProjects);
    setImgLoaded({}); // Reset loading states on tab change
  };

  const handleProjectDetails = (project) => {
    if (open) {
      setProjectDetails({});
      setOpen(false);
    } else {
      setProjectDetails(project);
      setOpen(true);
    }
  };

  // const handleImageLoad = (index) => {
  //   setImgLoaded((prev) => ({ ...prev, [index]: true }));

  // };

  return (
    <>
      <Seo
        title="Our Projects | Residential & Commercial Architecture in Tirunelveli"
        description="Browse completed residential and commercial architecture, interior and 3D elevation projects by JB Architects & Engineers, Tirunelveli's trusted architectural firm."
        keywords={[
          "top house designers in tirunelveli",
          "modern residential floor plans",
          "commercial architecture design",
          "modern elevation design services",
          "modern house elevation design ideas",
        ]}
        path="/projects"
      />
      <div className="container">
        <Typography variant="h5" color="orange" textAlign="center" className="mt-4" >
          Projects
        </Typography>

        <ul className="nav nav-pills nav-fill">
          {projectTypes.map((type,index) => {
            const tabActive = type === tabValue ? "active" : "";
            const isFirstTab = index === 0 ;
            return (
              <li className="nav-item" onClick={() => handleChangeTab(type)} key={type} style={{ width: isMobile && isFirstTab ? "100%" : "25%" }}>
                <a className={`nav-link text-capitalize ${tabActive}`} href="#">
                  {type}
                </a>
              </li>
            );
          })}
        </ul>

        <Box sx={{ width: "100%", height: "100%", overflowY: "scroll", marginTop: "10px" }}>
          <ImageList variant="masonry" cols={isMobile ? 2 : 3} gap={8}>
            {projects.map((item, idx) => (
              <ImageListItem key={idx} className="image-container user-select-none" onClick={() => handleProjectDetails(item)} sx={{ position: "relative" }}>
                {/* {!imgLoaded[idx] && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#fff",
                      zIndex: 1,
                    }}
                  >
                    <LoadingSpinner />
                  </Box>
                )} */}
                 <ImageLoading img={imgLoaded[idx]}/>
                <img
                  srcSet={`${item.image[0]?.itemImageSrc}?w=248&fit=crop&auto=format&dpr=2 2x`}
                  src={`${item.image[0].itemImageSrc}?w=248&fit=crop&auto=format`}
                  alt={item?.title}
                  loading="lazy"
                  className="image"
                  onLoad={() => handleImageLoad(idx,setImgLoaded)}
                  style={{ opacity: imgLoaded[idx] ? 1 : 0, transition: "opacity 0.5s ease-in-out" }}
                />

                <div className="dark-overlay"></div>
                <div className="overlay-text">{item?.name}</div>
              </ImageListItem>
            ))}
          </ImageList>
        </Box>

        {projects.length === 0 && <NoData displayMsg={`No data found for ${tabValue}`} />}
      </div>

      {open && (
        <ProjectDetails
          open={open}
          setOpen={setOpen}
          handleOpen={handleProjectDetails}
          project={projectDetails}
        />
      )}
    </>
  );
};

export default Projects;
